import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { styled } from 'styled-components';
import { PoweredByLink } from '../PoweredByLink';
import { FooterSharedStyles, FooterWedge } from './FooterSharedStyles';
export const FooterWithLeftLogo = () => {
    return (_jsxs(FooterWithLeftLogoRoot, { children: [_jsx(PoweredByLink, {}), _jsx(FooterWedge, {})] }));
};
const FooterWithLeftLogoRoot = styled.div `
    ${FooterSharedStyles}
    display: flex;
    align-items: center;
    justify-content: center;

    @media (min-width: 32.5rem) {
        justify-content: flex-start;
    }
`;
